import { useMemo, useState } from "react";
import { Transaction } from "../types/Product";
import { useProductList } from "./useProductList";

export const useTransaction = () => {
  const productList = useProductList();
  const [allTransactions, setAllTransactions] = useState<
    Record<string, Transaction[]>
  >(JSON.parse(localStorage.getItem("allTransactions") || "{}"));
  const transactions = useMemo(
    () => allTransactions[productList.current] || [],
    [allTransactions],
  );

  const addTransaction = (newTransaction: Transaction) => {
    const newAllTransactions = {
      ...allTransactions,
      [productList.current]: [...transactions, newTransaction],
    };
    localStorage.setItem("allTransactions", JSON.stringify(newAllTransactions));
    setAllTransactions(newAllTransactions);
  };
  const clearTransactions = () => {
    const newAllTransactions = { ...allTransactions };
    delete newAllTransactions[productList.current];
    localStorage.setItem("allTransactions", JSON.stringify(newAllTransactions));
    setAllTransactions(newAllTransactions);
  };
  return { transactions, addTransaction, clearTransactions };
};
